export default __webpack_public_path__ + "static/pro@mob_2x-cf23ba1a3a919e10c70aa234e2d68ce7.png";